module.exports = __webpack_public_path__ + "static/007_001-c31b226cb3bbd680f1f8c2ffd27fbc56.jpg";